
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class ErrorAlert extends Vue {
  @Prop({ type: [String, Array], default: [] }) message!: string | Array<string>;

  get messages(): string[] {
    let items = this.message;
    if (!Array.isArray(items)) {
      items = [items];
    }
    return items;
  }
}
